export class DigitalMarketing {
  
  public socialMediaCarouselItems: Array<{ title: string; categories: Array<string>, active?: boolean }> = [
    {
      title: 'Social media audit',
      categories: [],
      active: true
    }, {
      title: 'Analysis and strategy',
      categories: [],
    }, {
      title: 'Social media network management',
      categories: []
    }, {
      title: 'Content promotion',
      categories: []
    }, {
      title: 'Blog strategy and execution',
      categories: []
    }, {
      title: 'Community building, monitoring and management',
      categories: []
    }, {
      title: 'Software',
      categories: []
    }, {
      title: 'Social media monitoring and analysis',
      categories: []
    }, {
      title: 'Social media advertising',
      categories: []
    }, {
      title: 'Reputation management',
      categories: []
    }, {
      title: 'Influencers',
      categories: []
    }
  ];
  
}